const id = {
  quickReplyPreviewDialogTitle: "Template Preview",
  quickReplyPreviewLoading: "Memuat Preview Quick Reply",
  quickReplyPreviewList: "Cek disini",
  quickReplyPreviewSend: "Kirim",
  quickReplyPreviewCancel: "Batal",
  quickReplyPreviewError: "Tidak dapat menampilkan preview",
};

const en = {
  quickReplyPreviewLoading: "Loading Quick Reply Preview",
  quickReplyPreviewDialogTitle: "Template Preview",
  quickReplyPreviewList: "Check here",
  quickReplyPreviewSend: "Send",
  quickReplyPreviewCancel: "Cancel",
  quickReplyPreviewError: "Unable to display preview",
};

export default { id, en };
